"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compactIntWithDecimals = compactIntWithDecimals;
exports.formatCompact = void 0;
exports.numToPercentage = numToPercentage;
exports.priceWithCurrency = priceWithCurrency;

/** Formats a number in the format 1000 => 1K */
var formatCompact = function formatCompact(number) {
  try {
    return new Intl.NumberFormat(navigator.language, {
      notation: 'compact'
    }).format(number);
  } catch (_unused) {
    return number.toString();
  }
};
/** Turns number into percentage (includes % symbol) */


exports.formatCompact = formatCompact;

function numToPercentage(numerator, denominator) {
  var percentage = numerator && denominator && typeof numerator === 'number' && typeof denominator === 'number' ? Math.round(numerator / denominator * 100) : 0;
  return "".concat(percentage, "%");
}
/** Formats number with proper currency symbol  */


function priceWithCurrency(num, currencyCode) {
  var price = num && typeof num === 'number' ? num : 0;

  var fmt = function fmt(display) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode || 'USD',
      currencyDisplay: display
    }).format(price);
  };

  try {
    return fmt('narrowSymbol');
  } catch (_unused2) {
    try {
      return fmt('symbol');
    } catch (_unused3) {
      // if currencyCode is off, fmt will throw. Return the input in that case
      return num;
    }
  }
}
/**
 * Returns a string formatted to be a "compact int" - eg. 12345 → 12.3K.
 * @deprecated This function is deprecated and formatCompact() should be used instead.
 */


function compactIntWithDecimals(input) {
  var unclampedDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var output;
  var outputNumber;
  var decimals = Math.max(unclampedDecimals, 0);
  var numberLengths = [13, 10, 7, 4];
  var bigNumPrefixes = ['T', 'B', 'M', 'K'];
  var number = parseInt(input === null || input === void 0 ? void 0 : input.toString(), 10);
  var unsignedNumber = Math.abs(number);
  var unsignedNumberString = unsignedNumber.toString();
  var signString = number < 0 ? '-' : '';
  var numberLength = unsignedNumberString.length;

  if (unsignedNumber < 1000) {
    return "".concat(signString).concat(unsignedNumberString);
  }

  if (numberLength > numberLengths[0] + 3) {
    return number.toExponential(decimals).replace('e+', 'x10^');
  }

  var length = numberLengths.find(function (numberLen) {
    return numberLength >= numberLen;
  }) || 4;
  var decimalIndex = numberLength - length + 1;
  var unsignedNumberCharacterArray = unsignedNumberString.split('');
  var wholePartArray = unsignedNumberCharacterArray.slice(0, decimalIndex);
  var decimalPartArray = unsignedNumberCharacterArray.slice(decimalIndex, decimalIndex + decimals + 1);
  var wholePart = wholePartArray.join('');
  var decimalPart = decimalPartArray.join('');

  if (decimalPart.length < decimals) {
    decimalPart += new Array(decimals - decimalPart.length + 1).join('0').toString();
  }

  if (decimals === 0) {
    output = "".concat(signString).concat(wholePart).concat(bigNumPrefixes[numberLengths.indexOf(length)]);
  } else {
    // ??? I think the (+(1.1)) syntax is casting this back to a number, maybe?
    outputNumber = (+('' + wholePart + '.' + decimalPart)).toFixed(decimals);
    output = "".concat(signString).concat(outputNumber).concat(bigNumPrefixes[numberLengths.indexOf(length)]);
  }

  return output;
}